import VoucherComponent from './src/components/voucher'

export default {
   components: {
      
   },
   routes: [
      ...VoucherComponent.routes,
   ],
   sub_routes: [
      ...VoucherComponent.sub_routes,
   ]
}

export const RewardsNav = [
   // { 
   //    icon: 'fa fa-columns',component: 'Dashboard', name: 'Dashboard', has_permission: false
   // },
]